module.exports = __webpack_public_path__ + "img/liveIcon.2e4cd960.svg";